import { Container, Grid } from '@material-ui/core'
import { AppContext } from 'AppContext'
import { ReactivateBadgeText, RequestType } from 'constants/Constants'
import { useContext, useEffect, useState } from 'react'
import useStyles from 'styles/useStyles'
import { FCWithAuth } from 'types/CommonTypes'
import { IActivateBadgeRequest } from '../interfaces/IActivateBadgeRequest'
import { activateBadgeRequest } from '../services/ImageService'

export const ReactivateBadge: FCWithAuth = () => {
    const { user } = useContext(AppContext)
    const classes = useStyles()
    const [time, setTime] = useState<number>(0)

    useEffect(() => {
        setTime(5)
        const activate = async () => {
            const payload: IActivateBadgeRequest = {
                wwId: user?.wwId,
                photoIntakeRequestTypeID: RequestType.ReactivateBadge.value,
                photoIntakeRequestTypeName: RequestType.ReactivateBadge.name,
            }
            try {
                const response = await activateBadgeRequest(payload)
                if (response.startsWith('ERROR -')) {
                    alert('useEffet - API error')
                }
            } catch (error) {
                console.log('useEffect-error', error)
            }
        }
        activate()
    }, [])

    return (
        <div className={classes.root}>
            <Container maxWidth="md">
                <Grid container className={classes.badgePadding}>
                    <Grid item xs={12}>
                        <Grid container className={classes.textInput}>
                            <Grid item xs={12}>
                                <div className={classes.title}>
                                    <h1>{ReactivateBadgeText.Title}</h1>
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <p className={classes.instructionsChoiceText}>
                            {ReactivateBadgeText.Messaging1} {time} {ReactivateBadgeText.Messaging2}
                        </p>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

ReactivateBadge.requiresAuth = true
ReactivateBadge.requiresAzure = true
